import { Link } from "react-router-dom";

function CompareBar({compare}){

  if(compare.length===0) return null;

  return(
    <div className="compare-bar card shadow-sm p-3 mt-4">

  <div className="d-flex align-items-center justify-content-between flex-wrap">

    {/* PRODUCTS */}
    <div className="d-flex gap-2 flex-wrap">
      {compare.map((p) => (
        <div
          key={p.id}
          className="border rounded px-2 py-1 bg-light small"
          style={{ minWidth: "120px", textAlign: "center" }}
        >
          {p.name}
        </div>
      ))}
    </div>

    {/* COMPARE BUTTON */}
    <Link
      to="/compare"
      state={{ compare }}
      className="btn btn-primary"
    >
      Compare
    </Link>

  </div>

</div>

  );
}

export default CompareBar;
